(function () {
  const COLLAPSED_CLASS = 'product-info__read-more-content--collapsed';
  const PREVIEW_MAX_HEIGHT = 150;
  const PANEL_CLOSE_MS = 320;
  const JUDGEME_ACTION_SELECTOR = [
    '.jm-action-buttons__button',
    '.jm-action-buttons a',
    '.jm-action-buttons button',
    '.jdgm-write-rev-link',
    '.jdgm-ask-question-btn',
    '.jdgm-widget-actions a',
    '.jdgm-widget-actions button'
  ].join(',');
  const JUDGEME_MODAL_SELECTOR = [
    '.jdgm-write-review-modal',
    '.jdgm-ask-question-modal',
    '.jdgm-review-widget-modal',
    '.jdgm-modal'
  ].join(',');

  let movedSource = null;
  let movedPlaceholder = null;
  let closingPanel = false;
  let deferContentRestore = false;
  let ignoreJudgeMeActionClick = false;

  function getPanel() {
    return document.querySelector('[data-we-pdp-side-panel]');
  }

  function isPanelOpen() {
    const panel = getPanel();
    return Boolean(panel && !panel.hidden && panel.classList.contains('is-open'));
  }

  function shouldMoveContent(content) {
    return Boolean(
      content?.hasAttribute('data-we-pdp-side-panel-move') ||
        content?.querySelector('#judgeme_product_reviews')
    );
  }

  function restoreMovedContent() {
    if (!movedSource || !movedPlaceholder?.parentNode) {
      movedSource = null;
      movedPlaceholder = null;
      return;
    }

    movedPlaceholder.parentNode.insertBefore(movedSource, movedPlaceholder);
    movedPlaceholder.remove();
    movedSource.classList.remove('we-pdp-side-panel__content');
    if (!movedSource.classList.contains('disclosure__content')) {
      movedSource.classList.add('disclosure__content');
    }
    movedSource = null;
    movedPlaceholder = null;
  }

  function getJudgeMeActionIdentity(el) {
    if (!el) return null;

    const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

    if (
      el.matches('.jdgm-write-rev-link, .jm-button--primary.jm-action-buttons__button') ||
      text.includes('bewertung schreiben') ||
      text.includes('write a review')
    ) {
      return 'write-review';
    }

    if (
      el.matches('.jdgm-ask-question-btn, .jm-button--secondary.jm-action-buttons__button') ||
      text.includes('frage stellen') ||
      text.includes('ask a question')
    ) {
      return 'ask-question';
    }

    return 'generic';
  }

  function isJudgeMeAction(el) {
    if (!el) return false;
    if (el.closest(JUDGEME_ACTION_SELECTOR)) return true;

    const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return (
      text.includes('bewertung schreiben') ||
      text.includes('write a review') ||
      text.includes('eine frage stellen') ||
      text.includes('ask a question')
    );
  }

  function findJudgeMeAction(identity, root = document) {
    const candidates = Array.from(root.querySelectorAll(JUDGEME_ACTION_SELECTOR));
    if (!candidates.length) return null;

    if (identity === 'write-review') {
      return (
        candidates.find((el) => /bewertung schreiben|write a review/i.test(el.textContent || '')) ||
        candidates.find((el) => el.matches('.jm-button--primary.jm-action-buttons__button, .jdgm-write-rev-link')) ||
        null
      );
    }

    if (identity === 'ask-question') {
      return (
        candidates.find((el) => /frage stellen|ask a question/i.test(el.textContent || '')) ||
        candidates.find((el) => el.matches('.jm-button--secondary.jm-action-buttons__button, .jdgm-ask-question-btn')) ||
        null
      );
    }

    return candidates[0] || null;
  }

  function isJudgeMeModalOpen() {
    return Array.from(document.querySelectorAll(JUDGEME_MODAL_SELECTOR)).some((el) => {
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    });
  }

  function waitForJudgeMeModal(timeoutMs = 1000) {
    return new Promise((resolve) => {
      const startedAt = Date.now();

      const tick = () => {
        if (isJudgeMeModalOpen()) {
          resolve(true);
          return;
        }

        if (Date.now() - startedAt >= timeoutMs) {
          resolve(false);
          return;
        }

        window.requestAnimationFrame(tick);
      };

      tick();
    });
  }

  function openPanel({ content, title }) {
    const panel = getPanel();
    const panelBody = panel?.querySelector('[data-we-pdp-side-panel-body]');
    if (!panel || !panelBody || !content) return;

    const titleEl = panel.querySelector('[data-we-pdp-side-panel-title]');

    restoreMovedContent();
    deferContentRestore = false;
    ignoreJudgeMeActionClick = false;
    panel.style.zIndex = '';
    panel.classList.remove('we-pdp-side-panel--yielding', 'we-pdp-side-panel--arming');

    if (shouldMoveContent(content)) {
      movedSource = content;
      movedPlaceholder = document.createComment('we-pdp-side-panel-placeholder');
      content.parentNode?.insertBefore(movedPlaceholder, content);
      content.classList.remove(COLLAPSED_CLASS, 'disclosure__content');
      content.classList.add('we-pdp-side-panel__content');
      panelBody.replaceChildren(content);
    } else {
      const clone = content.cloneNode(true);
      clone.classList.remove(COLLAPSED_CLASS, 'disclosure__content', 'product-info__side-panel-content');
      clone.classList.add('we-pdp-side-panel__content');
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      panelBody.replaceChildren(clone);
    }

    if (titleEl) titleEl.textContent = title || 'Details';

    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('is-open'));
    document.body.classList.add('overflow-hidden');

    if (panelBody.querySelector('#judgeme_product_reviews')) {
      window.weMountJudgeMeReviewWidget?.();
    }

    panel.querySelector('[data-we-pdp-side-panel-close]')?.focus();
  }

  function openPanelFromButton(button) {
    const content = button.parentElement?.querySelector('.product-info__read-more-content');
    const title =
      button.dataset.panelTitle ||
      button.closest('details')?.querySelector('.disclosure__title')?.textContent?.trim() ||
      'Mehr lesen';

    openPanel({ content, title });
  }

  function openPanelFromDetails(details) {
    if (!details) return;

    const content =
      details.querySelector('.product-info__side-panel-content') ||
      details.querySelector('.product-info__read-more-content');
    const title =
      details.dataset.panelTitle ||
      details.querySelector('.disclosure__title')?.textContent?.trim() ||
      'Details';

    openPanel({ content, title });
  }

  function openReviewsPanel() {
    const details = document.querySelector('[data-we-pdp-side-panel-trigger][data-panel-reviews]');
    if (!details) return false;
    openPanelFromDetails(details);
    return true;
  }

  function closePanel(reinit = true, onClosed) {
    const panel = getPanel();
    if (!panel) {
      if (typeof onClosed === 'function') onClosed();
      return;
    }

    if (!panel.classList.contains('is-open')) {
      if (typeof onClosed === 'function') onClosed();
      return;
    }

    if (closingPanel) return;
    closingPanel = true;

    const drawer = panel.querySelector('.we-pdp-side-panel__drawer');
    const panelBody = panel.querySelector('[data-we-pdp-side-panel-body]');
    let finished = false;

    const finish = () => {
      if (finished) return;
      finished = true;
      closingPanel = false;

      drawer?.removeEventListener('transitionend', onTransitionEnd);

      if (!panel.classList.contains('is-open')) {
        panel.hidden = true;

        if (!deferContentRestore) {
          if (movedSource) {
            restoreMovedContent();
            panelBody?.replaceChildren();
          } else {
            panelBody?.replaceChildren();
          }
        }

        panel.style.zIndex = '';
        panel.classList.remove('we-pdp-side-panel--yielding');
      }

      if (reinit) {
        initReadMore(document);
      }

      if (typeof onClosed === 'function') onClosed();
    };

    const onTransitionEnd = (event) => {
      if (event.target !== drawer) return;
      if (event.propertyName !== 'transform') return;
      finish();
    };

    panel.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    drawer?.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(finish, PANEL_CLOSE_MS);
  }

  function cleanupArmedPanel(panel) {
    const panelBody = panel?.querySelector('[data-we-pdp-side-panel-body]');
    deferContentRestore = false;
    ignoreJudgeMeActionClick = false;

    if (panel) {
      panel.hidden = true;
      panel.classList.remove('we-pdp-side-panel--arming', 'we-pdp-side-panel--yielding', 'is-open');
      panel.style.zIndex = '';
    }

    if (movedSource) {
      restoreMovedContent();
      panelBody?.replaceChildren();
    }

    if (isJudgeMeModalOpen()) {
      document.body.classList.add('overflow-hidden');
    }
  }

  function preserveScroll(fn) {
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    const restore = () => window.scrollTo(scrollX, scrollY);

    const result = fn(restore);
    restore();
    return result;
  }

  function triggerJudgeMeAfterDrawerClose(identity) {
    const panel = getPanel();
    if (!panel) return;

    const lockedScrollY = window.__wePdpLockedScrollY ?? window.scrollY;

    // Keep reviews mounted invisibly so Judge.me can open write-review / ask-question.
    deferContentRestore = true;
    panel.hidden = false;
    panel.classList.add('we-pdp-side-panel--arming');
    panel.classList.remove('is-open');

    const root = panel;
    let action = findJudgeMeAction(identity, root);

    // Write-review: try revamp button first, then legacy link.
    if (identity === 'write-review') {
      action =
        root.querySelector('.jm-button--primary.jm-action-buttons__button') ||
        root.querySelector('.jdgm-write-rev-link') ||
        action;
    }

    if (!action) {
      cleanupArmedPanel(panel);
      window.scrollTo(0, lockedScrollY);
      return;
    }

    ignoreJudgeMeActionClick = true;

    preserveScroll(() => {
      action.click();

      // Fallback for write-review if the primary button did not open the modal.
      if (identity === 'write-review') {
        window.setTimeout(() => {
          if (isJudgeMeModalOpen()) return;
          const link = root.querySelector('.jdgm-write-rev-link');
          if (link && link !== action) {
            link.click();
          }
        }, 80);
      }
    });

    waitForJudgeMeModal().then((opened) => {
      ignoreJudgeMeActionClick = false;
      window.scrollTo(0, lockedScrollY);

      if (!opened) {
        cleanupArmedPanel(panel);
        window.scrollTo(0, lockedScrollY);
        return;
      }

      // Keep reviews mounted while the Judge.me modal is open.
      // Restoring too early can close the ask-question modal and jump scroll.
      const startedAt = Date.now();
      const watch = window.setInterval(() => {
        if (isJudgeMeModalOpen() && Date.now() - startedAt < 5 * 60 * 1000) return;

        window.clearInterval(watch);
        cleanupArmedPanel(panel);
        window.scrollTo(0, lockedScrollY);
        delete window.__wePdpLockedScrollY;
      }, 200);
    });
  }

  function handleJudgeMeActionFromDrawer(actionEl) {
    const identity = getJudgeMeActionIdentity(actionEl);
    const scrollY = window.scrollY;
    window.__wePdpLockedScrollY = scrollY;
    deferContentRestore = true;

    const panel = getPanel();
    if (!panel) return;

    // Start the drawer close animation, then open Judge.me only after it finishes.
    // Do not rely on transitionend alone — it can fire early and open the modal too soon.
    closingPanel = true;
    panel.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    window.scrollTo(0, scrollY);

    window.setTimeout(() => {
      closingPanel = false;
      if (!panel.classList.contains('is-open')) {
        panel.hidden = true;
      }
      window.scrollTo(0, scrollY);
      triggerJudgeMeAfterDrawerClose(identity);
    }, PANEL_CLOSE_MS + 40);
  }

  function initReadMore(scope = document) {
    scope.querySelectorAll('.product-info__read-more-content').forEach((content) => {
      const panel = getPanel();
      if (panel?.contains(content)) return;

      const button = content.parentElement?.querySelector('[data-product-info-read-more]');
      if (!button) return;

      content.classList.remove(COLLAPSED_CLASS);
      button.hidden = true;

      if (content.scrollHeight <= PREVIEW_MAX_HEIGHT) return;

      content.classList.add(COLLAPSED_CLASS);
      button.hidden = false;
      button.textContent = 'Mehr lesen';
    });
  }

  function isSidePanelSummaryClick(event) {
    const details = event.target.closest('[data-we-pdp-side-panel-trigger]');
    if (!details) return null;

    const summary = details.querySelector(':scope > summary');
    if (!summary || !summary.contains(event.target)) return null;

    return details;
  }

  function bindEvents() {
    if (window.__wePdpReadMoreBound) return;
    window.__wePdpReadMoreBound = true;

    window.wePdpOpenReviewsPanel = openReviewsPanel;

    // Capture phase so we run before DetailsDisclosure's summary click handler.
    document.addEventListener(
      'click',
      (event) => {
        const details = isSidePanelSummaryClick(event);
        if (!details) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        details.open = false;
        details.classList.remove('is-closing');
        openPanelFromDetails(details);
      },
      true
    );

    // Both Judge.me actions: close drawer first, then open the popup. No hash scroll.
    document.addEventListener(
      'click',
      (event) => {
        if (ignoreJudgeMeActionClick) return;
        if (!isPanelOpen()) return;

        const panel = getPanel();
        const action = event.target.closest(JUDGEME_ACTION_SELECTOR);
        if (!action || !panel?.contains(action) || !isJudgeMeAction(action)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        handleJudgeMeActionFromDrawer(action);
      },
      true
    );

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-product-info-read-more]');
      if (openButton) {
        event.preventDefault();
        event.stopPropagation();
        openPanelFromButton(openButton);
        return;
      }

      if (event.target.closest('[data-we-pdp-side-panel-close]')) {
        event.preventDefault();
        closePanel();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && getPanel()?.classList.contains('is-open')) {
        closePanel();
      }
    });

    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement)) return;

        if (details.matches('[data-we-pdp-side-panel-trigger][open]')) {
          details.open = false;
          openPanelFromDetails(details);
          return;
        }

        if (details.matches('.product-info details[open]')) {
          requestAnimationFrame(() => initReadMore(details));
        }
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initReadMore());
    } else {
      initReadMore();
    }

    document.addEventListener('shopify:section:load', (event) => initReadMore(event.target));
    document.addEventListener('we:pdp:content-updated', (event) => {
      initReadMore(event.target.closest('.product-info') || document);
    });
  }

  bindEvents();
})();
